import React, { useEffect, useState } from "react";
import { Card, Row, Col, message, Button, Table, Spin, Typography, Modal } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import TestimonialForm from "./TestimonialForm";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";

const { Title } = Typography;

const TestimonialList = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      setLoading(true);
      const response = await axios.get("http://93.127.203.113:5005/testimonials");
      setTestimonials(response.data);
    } catch (error) {
      message.error("Failed to load testimonials.");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (record) => {
    setFormData(record);
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`http://93.127.203.113:5005/testimonials/${id}`);
      message.success("Testimonial deleted successfully");
      fetchTestimonials();
    } catch (error) {
      message.error("Failed to delete testimonial.");
    }
  };

  const columns = [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Company", dataIndex: "company", key: "company" },
    { title: "Message", dataIndex: "message", key: "message" },

    {
      title: <span style={{ fontWeight: "bold", color: "#0c8c49" }}>Actions</span>,
      key: "actions",
      render: (_, record) => (
        <>
          {/* Edit Button */}
          <Button type="link" icon={<EditOutlined />} onClick={() => handleEdit(record)} style={{ color: "#0c8c49" }}>
            Edit
          </Button>

          {/* Details Link */}
          <Link to={`/testimonialDetails/${record.id}`} style={{ color: "#0c8c49", marginLeft: 10 }}>
            <InfoCircleOutlined /> Details
          </Link>

          {/* Delete Button */}
          <Button type="link" icon={<DeleteOutlined />} onClick={() => handleDelete(record.id)} danger style={{ marginLeft: 10 }}>
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Card style={{ borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
        <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>Testimonials</Title>
        <Row justify="end" style={{ marginBottom: "20px" }}>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => setModalVisible(true)}>
            Add Testimonial
          </Button>
        </Row>
        {loading ? <Spin size="large" /> : <Table columns={columns} dataSource={testimonials} rowKey="id" />}
      </Card>

      <Modal visible={modalVisible} footer={null} onCancel={() => setModalVisible(false)} destroyOnClose>
        <TestimonialForm formData={formData} setFormData={setFormData} closeModal={() => setModalVisible(false)} refetchData={fetchTestimonials} />
      </Modal>
    </div>
  );
};

export default TestimonialList;
